// @flow

// these are aligned with the values used by the Ant Design Grid
const breakpoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600
};

export default breakpoints;
